// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"checkbox__3quqC","filesIcon":"filesIcon__pqEMa"};